"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Truncate = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactResponsive = require("react-responsive");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils");
var _excluded = ["children", "splitPosition"];
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Truncate = (0, _styledComponents.default)(function (_ref) {
  var children = _ref.children,
    splitPosition = _ref.splitPosition,
    props = _objectWithoutProperties(_ref, _excluded);
  var isMd = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.md
  });
  var isXl = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.xl
  });
  var SPLIT_POSITION = isXl ? 10 : 14;
  var truncateSplitPosition = splitPosition !== null && splitPosition !== void 0 ? splitPosition : SPLIT_POSITION;
  return /*#__PURE__*/_react.default.createElement("div", props, isMd ? children : children.substr(0, truncateSplitPosition) + '...' + children.substr(-truncateSplitPosition));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  ", "\n"])), _utils.mediaQuery.lessThan('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    max-width: 170px;\n  "]))));
exports.Truncate = Truncate;